import { createSelector } from 'reselect';
import CarditNestingDetailsColumns
  from '../../containers/CarditNestingDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.CARDIT_NESTING_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_NESTING_DETAILS.isLoading;

export const getData =
  ReportDefinitions.CARDIT_NESTING_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, CarditNestingDetailsColumns);
